module.exports = __webpack_public_path__ + "img/190.dirty_stairs.4749b4d5.svg";